import React, { useEffect, useState } from "react";
import SelectTpDamage from "../Common/CustomSelect/SelectTpDamage";
import * as Icons from "heroicons-react";
import { Textarea } from "react-daisyui";
import { BsCheckSquare, BsSquare } from "react-icons/bs";

const AdjustProducts = ({
  adjustProducts,
  i,
  handleCustomQty,
  removeFromCart,
  handleOnChangePrice,
  handleCustomReason,
  handleDeSelectIsType,
  handleIsType,
}) => {
  return (
    <>
      {adjustProducts?.length > 0 ? (
        adjustProducts
          ?.slice()
          ?.sort((a, b) => a.order - b.order)
          ?.map((item, idx) => {
            const rowTotal = (
              (Number(item?.tp) || 0) * (Number(item?.qty) || 0)
            ).toFixed(2);

            return (
              <tr key={item?.id || item?.article_code || idx}>
                <th>{idx + 1}</th>
                <td>{item?.article_code}</td>
                <td>{item?.name}</td>
                <td>
                  {Boolean(item?.type) ? (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDeSelectIsType(item?.article_code)}
                    >
                      <BsCheckSquare className="d-inline text-success me-1" /> In
                    </span>
                  ) : (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => handleIsType(item?.article_code)}
                    >
                      <BsSquare className="d-inline text-danger me-1" /> Out
                    </span>
                  )}
                </td>
                <td className="col-md-2">
                  <div className="input-group">
                    <input
                      type="number"
                      min="1"
                      className="form-control quantity"
                      id={item?.article_code}
                      onChange={(e) =>
                        handleCustomQty(e.target.value, item?.article_code)
                      }
                      value={item?.qty ?? 1}
                    />
                  </div>
                </td>
                <td>
                  <SelectTpDamage
                    sc={item?.id}
                    setVal={item?.tp ?? 0}
                    handleOnChangeCategory={handleOnChangePrice}
                  />
                </td>
                <td>{rowTotal}</td>
                <td>
                  <Textarea
                    type="text"
                    className="form-control quantity"
                    rows="1"
                    value={item?.reason || ""}
                    onChange={(e) =>
                      handleCustomReason(e.target.value, item?.article_code)
                    }
                  />
                </td>
                <td>
                  <Icons.X
                    size={20}
                    style={{ cursor: "pointer" }}
                    className="text-danger"
                    onClick={() => removeFromCart(item?.id || item?.article_code)}
                  />
                </td>
              </tr>
            );
          })
      ) : (
        <tr>
          <td colSpan={9} className="text-center py-3 text-muted">
            No products added for adjustment yet.
          </td>
        </tr>
      )}
    </>
  );
};

export default AdjustProducts;
